import { render, staticRenderFns } from "./band-banner-form.vue?vue&type=template&id=0a6c9a22&"
import script from "./band-banner-form.vue?vue&type=script&lang=js&"
export * from "./band-banner-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports